import React, { useState } from 'react';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/mobile.css";
import InputIcon from "react-multi-date-picker/components/input_icon";
import moment from 'jalali-moment'
import { changeFaToEn } from '../functions/changeFaToEn';



const MyDatePicker = ({ setDate }) => {



    function handleDateChange(e) {

        const jalaliDate = changeFaToEn(e.toString())

        const gregorianDate = moment(jalaliDate, 'jYYYY-jMM-jDD').locale('en').format('YYYY-MM-DD')
        
        setDate(gregorianDate);
    }

    return (

        <>

            <DatePicker

                style={{
                    width: "100%",
                    boxSizing: "border-box",
                    height: "26px"
                }}
                containerStyle={{
                    width: "100%"
                }}
                render={<InputIcon />}
                className="rmdp-mobile"
                // minDate={new DateObject({ calendar: persian }).subtract(-1, "days")}
                // maxDate={new DateObject({ calendar: persian }).add(max, "days")}
                calendar={persian}
                locale={persian_fa}
                calendarPosition="bottom-right"
                disableMonthPicker
                disableYearPicker

                format="YYYY-MM-DD"


                onChange={handleDateChange}

            />

        </>
    );
};

export default MyDatePicker;
